import React from 'react';

const Footer = () => {
  return (
    <footer className="footer bg-gray-800 text-white py-8">
      <p className="mb-2">&copy; 2025 Offentligt Ansattes Organisationer</p>
      <div className="flex justify-center space-x-4">
        <a href="https://www.oao.dk/om-oao" className="text-white underline hover:text-red-600">Om OAO</a>
        <a href="https://www.oao.dk/kontakt" className="text-white underline hover:text-red-600">Kontakt</a>
      </div>
    </footer>
  );
};

export default Footer;
